
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hNmwG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2d0ff83c42df68e6$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $2d0ff83c42df68e6$export$2e2bcd8739ae039 = {
    'fabric.editor.chromeCollapsedPlaceholder': "Napi\u0161te n\u011Bco\u2026",
    'fabric.editor.editorAssistiveLabel': "Hlavn\xed oblast obsahu. Za\u010Dn\u011Bte ps\xe1t, abyste zadali text.",
    'fabric.editor.headingLink.toolbarHelpTitle': "Otev\u0159\xedt dialog n\xe1pov\u011Bdy"
};

});


//# sourceMappingURL=cs.aa1f82d3.js.map
